import { render, staticRenderFns } from "./AlbumCollection.vue?vue&type=template&id=09137fc5&scoped=true&"
import script from "./AlbumCollection.vue?vue&type=script&lang=js&"
export * from "./AlbumCollection.vue?vue&type=script&lang=js&"
import style0 from "./AlbumCollection.vue?vue&type=style&index=0&id=09137fc5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09137fc5",
  null
  
)

export default component.exports